import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class CheckoutApi extends Api {
  readonly url = "/v2/checkouts/";

  constructor($axios: Context["$axios"]) {
    super("checkoutService", $axios);
  }

  async post(data: PostCheckoutParams) {
    return await this.request<OneCheckoutResponse>({
      method: "POST",
      data,
    });
  }
}
